export const defaultLocale = "en" as const;
export const locales = ["en", "pl", "de", "es", "fr"] as const;

export type Locale = (typeof locales)[number];

export const localeNames: Record<Locale, string> = {
  en: "English",
  pl: "Polski",
  de: "Deutsch",
  es: "Español",
  fr: "Français",
};

// ISO 3166-1-alpha-2 country codes for flag SVG files
export const localeFlagCodes: Record<Locale, string> = {
  en: "gb", // Great Britain
  pl: "pl", // Poland
  de: "de", // Germany
  es: "es", // Spain
  fr: "fr", // France
};
